enum BrandProfileAssetType {
    FILE = 'file',
}

export default BrandProfileAssetType;
